var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAgreements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F9F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 27V13C2 11.1144 2 10.1716 2.58579 9.58579C3.17157 9 4.11438 9 6 9H16C16.8317 9 17.4778 9 18.0037 9.02706C15.7519 9.2741 14 11.1825 14 13.5V17.0002L13.9012 26.9671L11 26L8 27L5 26L2 27ZM21 17L16 17V13.5C16 12.1193 17.1193 11 18.5 11C19.8807 11 21 12.1193 21 13.5V17ZM4 13C4 12.4477 4.44772 12 5 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H5C4.44772 14 4 13.5523 4 13ZM4 17C4 16.4477 4.44772 16 5 16H7C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18H5C4.44772 18 4 17.5523 4 17ZM4 21C4 20.4477 4.44772 20 5 20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H5C4.44772 22 4 21.5523 4 21Z",
    fill: "#9E77ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAgreements);
export default __webpack_public_path__ + "static/media/TotalAgreements.6c5f31065725b5ff938bf89ac3ca3010.svg";
export { ForwardRef as ReactComponent };